export default "__VITE_ASSET__DUwDKhs8__"